const birdGIFPos1 = [ require('../../images/birdGIF/1/pos/1.png'), require('../../images/birdGIF/1/pos/2.png'), 
                    require('../../images/birdGIF/1/pos/3.png'), require('../../images/birdGIF/1/pos/4.png')
                  ];
const birdGIFNeg1 = [ require('../../images/birdGIF/1/neg/1.png'), require('../../images/birdGIF/1/neg/2.png'), 
                  require('../../images/birdGIF/1/neg/3.png'), require('../../images/birdGIF/1/neg/4.png')
                ];
const birdGIFPos2 = [ require('../../images/birdGIF/2/pos/1.png'), require('../../images/birdGIF/2/pos/2.png'), 
                require('../../images/birdGIF/2/pos/3.png'), require('../../images/birdGIF/2/pos/4.png')
              ];
const birdGIFNeg2 = [ require('../../images/birdGIF/2/neg/1.png'), require('../../images/birdGIF/2/neg/2.png'), 
              require('../../images/birdGIF/2/neg/3.png'), require('../../images/birdGIF/2/neg/4.png')
            ];

module.exports = {
    birdGIFPos1, birdGIFNeg1, birdGIFPos2, birdGIFNeg2
}